import * as ng from 'angular';

ng.module('selfReg')
   .directive('validatePostal', validatePostalDirective);

export function validatePostalDirective() {
   return {
      require: 'ngModel',
      link: validatePostalLink,
      scope: {
         country: '=validatePostal'
      }
   }
}

function validatePostalLink(scope:ng.IScope, elm, attrs, ctrl:ng.INgModelController) {
   let postalRegex:RegExp = null;

   scope.$watch('country', (country:any, oldVal) => {
      if (country) {
         postalRegex = new RegExp(country.postalRegex, 'i');
      } else {
         postalRegex = null;
      }

      ctrl.$validate();
   });

   ctrl.$validators.postal = isValidPostal;

   function isValidPostal(modelValue) {
      return ctrl.$isEmpty(modelValue) || !postalRegex || postalRegex.test(modelValue);
   }
}
